import { gql } from '@apollo/client';

export const GET_ADDRESS_RESIDENTIAL_AREA_LISTING = gql`
  query GetAddressResidentialAreaListing(
    $residentialName: String
    $residentialAddress: String  
    $cityName: String
    $stateAbbreviation: String
    $zipcode: String
    $status: ResidentialAreaStatus
    $creatorId: Long
    $createdAtRange: TimeRangeInput
    $page: Int!
    $size: Int!
  ) {
    addressResidentialAreaList(
      residentialName: $residentialName
      residentialAddress: $residentialAddress
      cityName: $cityName
      stateAbbreviation: $stateAbbreviation
      zipcode: $zipcode
      status: $status
      creatorId: $creatorId
      createdAtRange: $createdAtRange
      page: $page
      size: $size
    ) {
      content {
        id
        residentialAddress
        standardAddress  
        residentialName
        cityName
        stateAbbreviation
        zipcode
        createdAt
        updatedAt
        status
        creatorAccount
        auditorAccount
        images {
          id
          residentialAreaId
          imageS3Key
          stopNumber
          imageDisplayUrl
        }
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface AddressResidentialAreaImageType {
  id: string;
  residentialAreaId: number;
  imageS3Key: string;
  stopNumber: number;
  imageDisplayUrl?: string | null;
}

export interface AddressResidentialAreaType {
  id: string;
  residentialAddress: string;
  standardAddress: string;
  residentialName: string;
  cityName?: string | null;
  stateAbbreviation?: string | null;
  zipcode?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
    status?: number | null;
    creatorAccount?: string | null;
    auditorAccount?: string | null;
  images?: AddressResidentialAreaImageType[] | null;
}

export interface GetAddressResidentialAreaListingResponse {
  addressResidentialAreaList: {
    content: AddressResidentialAreaType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

